import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import uploadAttachmentWithProgress from '@savgroup-front-common/core/api/Attachment/uploadAttachmentWithProgress';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/additionalInformation/${COMMON_QUERY_PARAMS.CLAIM_ID}/${COMMON_QUERY_PARAMS.ID}/file`;

interface GetFilesByQueryArgs {
  fileId: string;
  claimId: string;
  additionalInformationId: string;
  file: File;
}

export async function setFileAdditionalInformationWithFilesCommand({
  fileId,
  claimId,
  additionalInformationId,
  file,
}: GetFilesByQueryArgs): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const url = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.ID,
      additionalInformationId,
    )
      .replace(COMMON_QUERY_PARAMS.FILE_ID, fileId)
      .replace(COMMON_QUERY_PARAMS.CLAIM_ID, claimId);

    const response = await uploadAttachmentWithProgress({
      file,
      endpoint: url,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
